import React, { useContext } from "react";
import { useState } from "react";
import "../../css_files/Master/AddPackingMaster.css";
import CloseForm from "./CloseForm";
import axios from "axios";
import { toast } from "react-toastify";
import getCookie from "../../api";
import Swal from "sweetalert2";
import axiosInstance from "../../api";
import LoadingScreen from "../Homepage/LoadingScreen";
import { triggerscroll } from "../Homepage/Homepage";

function AddPackingMaster({
  setshowaddform,
  reload,
  setReload,
  triggerupdate,
  packingupdatedata,
}) {
  const [packingData, setPackingData] = useState({
    Name: triggerupdate ? packingupdatedata?.name : "",
    UsedFor: triggerupdate ? packingupdatedata?.usedFor : "",
    Description: triggerupdate ? packingupdatedata?.description : "",
  });
  const [loading, setloading] = useState(false);
  const [message, setMessage] = useState("");
  const { setExpiredSession } = useContext(triggerscroll);

  function handleSubmit(e) {
    e.preventDefault();
    setloading(true);
    if (triggerupdate) {
      const url = `${process.env.REACT_APP_API_URL}/api/v1/Packing/UpdatePacking`;
      axiosInstance
        .post(url, {
          packingID: packingupdatedata.id,
          name: packingData.Name,
          usedFor: packingData.UsedFor,
          description: packingData.Description,
        })
        .then((res) => {
          toast.success(res.data.message, {
            position: "bottom-center",
            theme: "dark",
          });
          setshowaddform(false);
          setReload(!reload);
          setloading(false);
        })
        .catch((err) => {
          if (err.status === 500)
            Swal.fire({
              title: "Errors Occured",
              text: err.response.data.error,
              icon: "error",
            });
          else
            toast.error("Failed to Update", {
              position: "bottom-center",
              theme: "dark",
            });

          console.log(err);
          setloading(false);
        });
    } else {
      const URL = `${process.env.REACT_APP_API_URL}/api/v1/packing`;
      axiosInstance
        .post(URL, packingData)
        .then((response) => {
          toast.success("Record Added Successfully", {
            position: "bottom-center",
            theme: "dark",
          });
          setshowaddform(false);
          setReload(!reload);
          setloading(false);
        })
        .catch((error) => {
          if (error.status === 500)
            Swal.fire({
              title: "Errors Occured",
              text: error.response.data.error,
              icon: "error",
            });
          else
            toast.error("Failed to Add Record", {
              position: "bottom-center",
              theme: "dark",
            });

          console.log(error);
          setloading(false);
        });
    }
  }

  return (
    <form className="add-packing-master" onSubmit={handleSubmit}>
      <blockquote>
        <label>
          Packing Name{" "}
          <sup>
            <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
          </sup>
        </label>
        <input
          type="text"
          placeholder="Enter Packing Master Name"
          value={packingData.Name}
          onChange={(e) =>
            setPackingData({ ...packingData, Name: e.target.value })
          }
          onInput={(e) => {
            e.target.value = e.target.value.slice(0, 100);
            axiosInstance
              .get(
                `${process.env.REACT_APP_API_URL}/api/v1/Packing/GetPackingByIdAndName?name=${e.target.value}`
              )
              .then(() => setMessage("Packing Already Exists With this Name"))
              .catch((error) => {
                setMessage("");
              });
          }}
          required
        />
        <span style={{ color: "red" }}>{message}</span>
      </blockquote>
      <blockquote>
        <label>
          Used For{" "}
          <sup>
            <i class="fa-solid fa-asterisk" style={{ color: "red" }}></i>
          </sup>
        </label>
        <input
          type="text"
          placeholder="Enter Used For"
          value={packingData.UsedFor}
          onChange={(e) =>
            setPackingData({ ...packingData, UsedFor: e.target.value })
          }
          onInput={(e) => {
            e.target.value = e.target.value
              .replace(/[^a-zA-Z\s]/g, "")
              .slice(0, 100);
          }}
          required
        />
      </blockquote>
      <blockquote>
        <label>Description</label>
        <textarea
          rows={5}
          placeholder="Enter Description (Upto 400 Characters)"
          value={packingData.Description}
          onChange={(e) =>
            setPackingData({ ...packingData, Description: e.target.value })
          }
          onInput={(e) => {
            e.target.value = e.target.value.slice(0, 400);
          }}
        ></textarea>
      </blockquote>
      <button type="submit">{triggerupdate ? "Update" : "Add"} </button>
      <CloseForm close={setshowaddform} />
      {loading && <LoadingScreen />}
    </form>
  );
}

export default AddPackingMaster;
